export enum BorderStyle {
  Solid,
  Dashed,
  Dotted,
  Double
}
